import QRCode from "qrcode";

export interface QRCodeWithLogoOptions {
  content: string;
  size?: number;
  logoSrc: string;
  logoRatio?: number;
  darkColor?: string;
  lightColor?: string;
}

export interface PosterOptions {
  backgroundSrc: string;
  width: number;
  height: number;
  qrcode: { x: number; y: number; size: number };
  qrcodeContent: string;
  qrcodeLogoSrc: string;
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

export async function generateQRCodeWithLogo(
  options: QRCodeWithLogoOptions,
): Promise<HTMLCanvasElement> {
  const {
    content,
    size = 190,
    logoSrc,
    logoRatio = 0.22,
    darkColor = "#1a2356",
    lightColor = "#ffffff",
  } = options;

  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;

  await QRCode.toCanvas(canvas, content, {
    width: size,
    margin: 1,
    errorCorrectionLevel: "H",
    color: { dark: darkColor, light: lightColor },
  });

  const ctx = canvas.getContext("2d")!;
  const logo = await loadImage(logoSrc);

  const logoSize = Math.floor(size * logoRatio);
  const logoX = Math.floor((size - logoSize) / 2);
  const logoY = Math.floor((size - logoSize) / 2);

  // 白色圆角背景
  const padding = 4;
  ctx.fillStyle = "#ffffff";
  ctx.beginPath();
  ctx.roundRect(
    logoX - padding,
    logoY - padding,
    logoSize + padding * 2,
    logoSize + padding * 2,
    6,
  );
  ctx.fill();

  ctx.drawImage(logo, logoX, logoY, logoSize, logoSize);

  return canvas;
}

export async function generateSharePoster(
  options: PosterOptions,
): Promise<string> {
  const { backgroundSrc, width, height, qrcode, qrcodeContent, qrcodeLogoSrc } =
    options;

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d")!;

  const bgImage = await loadImage(backgroundSrc);
  ctx.drawImage(bgImage, 0, 0, width, height);

  const qrCanvas = await generateQRCodeWithLogo({
    content: qrcodeContent,
    size: qrcode.size * 2, // 2x 保证清晰
    logoSrc: qrcodeLogoSrc,
  });

  ctx.drawImage(qrCanvas, qrcode.x, qrcode.y, qrcode.size, qrcode.size);

  return canvas.toDataURL("image/png", 0.9);
}
